import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { currentPage } from '../gui/actions';
import MobileWrapper from  '../gui/MobileWrapper';
import recipe from '../assets/img/business/recipe.jpg';
import mobile from '../assets/img/business/mobile.jpg';
import student from '../assets/img/business/student.jpg';
import graph from '../assets/img/business/graph.jpg';
import Card from './Card';


class index extends React.Component {

	constructor() {
		super();
		this.state = {
			open: {},
		}
	}

	openCard(name) {
		this.setState({
			open: {...this.state.open,
				[name]: true,
			},
		})
	}

	render() {
		const { einbindung, rezepte, einBlick, gesundheit } = this.state.open;
		return (
			<MobileWrapper topNav={false}>
				<div className="content-padding">
					<Card
						img={mobile}
						headline='Einbinden von Bettergood'
						text='Die Einbindung von Bettergood in den Mensabetrieb erfolgt
									unkompliziert durch die BAGGID GmbH.'
						openCard={() => this.openCard('einbindung')}
						isOpen={einbindung} />
					<Card
						img={recipe}
						headline='Rezepte können in jeder Form geschickt werden'
						text='Partnermensen schicken
							ihre Menüpläne als Mail, Tabelle, oder einfach abfotografiert
							an die BAGGID GmbH.'
						openCard={() => this.openCard('einbindung')}
						isOpen={rezepte} />

					<Card
						img={student}
						headline='Alles auf einen Blick'
						text='Studenten und Besucher der Mensa sehen auf einen Blick den
									Menüplan und die Gesundheit aller Gerichte und können
									das Angebot nach ihren persönlichen Wünschen filtern.'
						openCard={() => this.openCard('einBlick')}
						isOpen={einBlick} />

					<Card
						img={graph}
						headline='Nachweisliche Verbesserung der Gesundheit'
						text='Als Partner erhalten Sie Einblick über die Verbesserung
									der Gesundheit ihrer Studenten und Besucher. Graphen
									zeigen Ihnen auf einen Blick wie viele Nutzer auf Grund der
									zusätzlichen Informationen zu gesünderen Alternativen greifen.'
						openCard={() => this.openCard('gesundheit')}
						isOpen={gesundheit} />

					<Link to="/app">
						<button 
							className="btn btn-brand full-width"
							onClick={() => this.props.currentPage('app')}>
								Sehen Sie selbst
						</button>
					</Link>

				</div>
			</MobileWrapper>
		);
	}
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  currentPage(name) {
		dispatch(currentPage(name));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(index);



// WEBPACK FOOTER //
// ./src/business/index.js